// utilities

export const log = (x) => console.log(x);

export const get = (x) => document.querySelector(x);

export const getAll = (x) => document.querySelectorAll(x);